export default __webpack_public_path__ + "static/media/South-America.b3d3d071.png";